/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".emp_recibidos__details--hidden[_ngcontent-%COMP%]{display:none}"];
export { styles as styles };
